import React, { useState, useRef } from 'react';
import { Upload, X, FileText, Loader2 } from 'lucide-react';
import { PrimaryButtonPurple } from './Buttons';
import { useSticker } from '../../context/StickerContext';
import { useToast } from './Toast';
export function UploadDropzone() {
  const {
    uploadedFile,
    setUploadedFile,
    uploadState,
    setUploadState
  } = useSticker();
  const {
    addToast
  } = useToast();
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef<HTMLInputElement>(null);
  const handleDragOver = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(true);
  };
  const handleDragLeave = () => {
    setIsDragging(false);
  };
  const handleDrop = (e: React.DragEvent) => {
    e.preventDefault();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files.length > 0) {
      simulateUpload(files[0]);
    }
  };
  const handleFileSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      simulateUpload(e.target.files[0]);
    }
  };
  const simulateUpload = (file: File) => {
    setUploadState('loading');
    // Simulate network delay
    setTimeout(() => {
      setUploadedFile({
        name: file.name,
        size: (file.size / 1024 / 1024).toFixed(2) + ' MB',
        thumbnail: URL.createObjectURL(file) // In real app, this would be from server
      });
      setUploadState('loaded');
      addToast('Upload complete');
    }, 1500);
  };
  const removeFile = () => {
    setUploadedFile(null);
    setUploadState('empty');
    addToast('File removed');
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };
  return <div className="w-full" data-id="element-255">
      <input type="file" ref={fileInputRef} onChange={handleFileSelect} className="hidden" accept=".png,.jpg,.jpeg,.svg,.pdf" data-id="element-256" />

      {uploadState === 'empty' && <div onDragOver={handleDragOver} onDragLeave={handleDragLeave} onDrop={handleDrop} className={`
            border-2 border-dashed rounded-xl p-8 flex flex-col items-center justify-center text-center transition-colors
            ${isDragging ? 'border-violet-500 bg-violet-50' : 'border-gray-300 bg-gray-50'}
          `} data-id="element-257">
          <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-sm mb-4" data-id="element-258">
            <Upload className="text-violet-600" size={24} data-id="element-259" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-1" data-id="element-260">
            Drop your files here
          </h3>
          <p className="text-sm text-gray-500 mb-6" data-id="element-261">or click to browse</p>

          <PrimaryButtonPurple onClick={() => fileInputRef.current?.click()} data-id="element-262">
            Choose Files
          </PrimaryButtonPurple>

          <div className="mt-6 text-xs text-gray-400 space-y-1" data-id="element-263">
            <p data-id="element-264">Raster and vector files supported.</p>
            <p data-id="element-265">Accepted: PNG, JPG, SVG, PDF</p>
          </div>
        </div>}

      {uploadState === 'loading' && <div className="border border-gray-200 rounded-xl p-6 bg-gray-50" data-id="element-266">
          <div className="flex items-center gap-4" data-id="element-267">
            <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center border border-gray-200" data-id="element-268">
              <Loader2 className="animate-spin text-violet-600" size={24} data-id="element-269" />
            </div>
            <div className="flex-1" data-id="element-270">
              <div className="h-2 w-full bg-gray-200 rounded-full overflow-hidden" data-id="element-271">
                <div className="h-full bg-violet-600 w-2/3 animate-pulse" data-id="element-272" />
              </div>
              <p className="text-sm text-gray-500 mt-2" data-id="element-273">Loading...</p>
            </div>
          </div>
        </div>}

      {uploadState === 'loaded' && uploadedFile && <div className="border border-gray-200 rounded-xl p-4 bg-white relative group" data-id="element-274">
          <button onClick={removeFile} className="absolute top-2 right-2 p-1 bg-gray-100 rounded-full hover:bg-red-100 hover:text-red-600 transition-colors" data-id="element-275">
            <X size={16} data-id="element-276" />
          </button>

          <div className="flex items-center gap-4" data-id="element-277">
            <div className="w-16 h-16 bg-gray-100 rounded-lg overflow-hidden flex items-center justify-center border border-gray-200" data-id="element-278">
              {uploadedFile.name.endsWith('.png') || uploadedFile.name.endsWith('.jpg') ? <img src={uploadedFile.thumbnail} alt="Preview" className="w-full h-full object-cover" data-id="element-279" /> : <FileText className="text-gray-400" size={32} data-id="element-280" />}
            </div>
            <div data-id="element-281">
              <p className="font-medium text-gray-900 truncate max-w-[200px]" data-id="element-282">
                {uploadedFile.name}
              </p>
              <p className="text-sm text-gray-500" data-id="element-283">{uploadedFile.size}</p>
            </div>
          </div>
        </div>}
    </div>;
}